import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';

import { AppCommonsModule } from '../../../commons/app-commons.module';

import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { KYMW1409Component } from './kymw1409.component';
import { DeleteUseMarkService } from './api-services/delete-use-mark.service';
import { GetMarkListService } from './api-services/get-mark-list.service';
import { RegistUseMarkService } from './api-services/regist-use-mark.service';


/**
 * マーク指示画面 モジュール設定クラス
 *
 * @export KYMW1409Module
 * @class KYMW1409Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjInputModule,
  ],
  declarations: [
    KYMW1409Component,
  ],
  providers: [
    DeleteUseMarkService,
    GetMarkListService,
    RegistUseMarkService,
  ],
})
export class KYMW1409Module {
}
